import {CtModelRouteData} from "@ctsolution/ct-framework";

export const FormGeneratorDataRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("formgeneratordata");
